<app-notes-by-category [notesCategory]="category"></app-notes-by-category>